<script>
import api from './api'
import fbService from './fb'

export default {
  loginWithFacebook () {
    return fbService.login().then((identity) => {
      return api.post('auth/connected', {provider: 'facebook', identity: identity})
    }).then((result) => {
      return result.data
    })
  },
  loginGuestWithFacebook () {
    return fbService.loginGuest().then((identity) => {
      return api.post('auth/connected', {provider: 'facebook', identity: identity})
    }).then((result) => {
      return result.data
    })
  },
  logout () {
  },
  isGuestLoginSupported () {
    return fbService.isGuestLoginSupported()
  },
  loginWithEmailAndPassword (data) {
    return api.post('auth/login', data)
      .then((result) => {
        return result.data
      })
  }
}
</script>



// WEBPACK FOOTER //
// auth.vue?4a758288